// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.imagesMainDiv {
    overflow-x: hidden;
}

.mainDiv {
    margin: 0 0 0 200px;
}

.mainDivIpad {
    margin: 0 0 0 10%;
}

.pageNumber {
    height: 55px;
    width: auto;
    background-color: rgb(248, 248, 248);
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 27.5px;
    padding: 0 30px 0 30px;
    cursor: pointer;
}

.unSelectedSpan {
    margin: 0 5px;
    font-family: 'Gilory-Semi';
    font-size: 20px;
    color: #d7d7d7;

}

.selectedSpan {
    margin: 0 5px;
    font-family: 'Gilory-Bold';
    font-size: 20px;
    color: #767676;
}

.tabDetails {
    margin-left: 200px;
}


.headerText{
    margin: 25px 0 0 0;
    position: absolute;
}

.autoUpdatesFilters {
    display: inline-flex;
    gap: 8px;
    margin-left: 18px;
    vertical-align: middle;
}

.autoUpdatesFilters button {
    border: 0;
    border-radius: 18px;
    background: transparent;
    color: #b8b8b8;
    cursor: pointer;
    font-family: 'Gilory-Semi';
    font-size: 16px;
    padding: 8px 12px;
}

.autoUpdatesFilters button.active {
    background: #f1f1f1;
    color: #767676;
    font-family: 'Gilory-Bold';
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/Images2.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,oCAAoC;IACpC,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,eAAe;IACf,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;;AAGA;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,QAAQ;IACR,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,0BAA0B;AAC9B","sourcesContent":[".imagesMainDiv {\n    overflow-x: hidden;\n}\n\n.mainDiv {\n    margin: 0 0 0 200px;\n}\n\n.mainDivIpad {\n    margin: 0 0 0 10%;\n}\n\n.pageNumber {\n    height: 55px;\n    width: auto;\n    background-color: rgb(248, 248, 248);\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 27.5px;\n    padding: 0 30px 0 30px;\n    cursor: pointer;\n}\n\n.unSelectedSpan {\n    margin: 0 5px;\n    font-family: 'Gilory-Semi';\n    font-size: 20px;\n    color: #d7d7d7;\n\n}\n\n.selectedSpan {\n    margin: 0 5px;\n    font-family: 'Gilory-Bold';\n    font-size: 20px;\n    color: #767676;\n}\n\n.tabDetails {\n    margin-left: 200px;\n}\n\n\n.headerText{\n    margin: 25px 0 0 0;\n    position: absolute;\n}\n\n.autoUpdatesFilters {\n    display: inline-flex;\n    gap: 8px;\n    margin-left: 18px;\n    vertical-align: middle;\n}\n\n.autoUpdatesFilters button {\n    border: 0;\n    border-radius: 18px;\n    background: transparent;\n    color: #b8b8b8;\n    cursor: pointer;\n    font-family: 'Gilory-Semi';\n    font-size: 16px;\n    padding: 8px 12px;\n}\n\n.autoUpdatesFilters button.active {\n    background: #f1f1f1;\n    color: #767676;\n    font-family: 'Gilory-Bold';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
